/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -9", "key": "svg-0" }], ["path", { "d": "M16 3l-4 4l-4 -4", "key": "svg-1" }]];
const IconDeviceTv = createReactComponent("outline", "device-tv", "DeviceTv", __iconNode);

export { __iconNode, IconDeviceTv as default };
//# sourceMappingURL=IconDeviceTv.mjs.map
